import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useLandingPageState() {
  return useAppState();
}

export function useLandingPageActions() {
  const dispatch = useAppDispatch();

  function initializeState(sharedAssetsPaths) {
    dispatch((appState) => ({
      ...appState,
      sharedAssetsPaths,
      showInvitationRequestWizard: false,
    }));
  }

  function openInvitationRequestWizard() {
    dispatch((appState) => ({
      ...appState,
      showInvitationRequestWizard: true,
    }));
  }

  function closeInvitationRequestWizard() {
    dispatch((appState) => ({
      ...appState,
      showInvitationRequestWizard: false,
    }));
  }

  return {
    initializeState,
    openInvitationRequestWizard,
    closeInvitationRequestWizard,
  };
}
